<template>
    <div
        class="rounded border primary mt-1 mb-1 py-2 task-push--static"
        :id="`popover-${type}-${index}`"
    >
        <div>
            <b-row v-if="type != 0">

                <b-col>
                   
				    <b-button
                        size="sm"
                        @click.prevent="addTask(1)"
                        variant="light"
                        class="float-right mr-3"
                        >+ Task</b-button
                    >
                </b-col>
            </b-row>

            <b-row v-else>
                <b-col>
                    <b-button
                        size="sm"
                        @click.prevent="addTask(1)"
                        variant="light"
                        class="float-right mr-3"
                        >+ Task</b-button
                    >
                    <b-button
                        size="sm"
                        @click.prevent="addTask(2)"
                        class="float-right mr-3"
                        variant="light"
                        >+ Check-out</b-button
                    >
                    <b-button
                        size="sm"
                        @click.prevent="addTask(0)"
                        class="float-right mr-3"
                        variant="light"
                        >+ Check-in</b-button
                    >
                </b-col>
            </b-row>
        </div>

        <b-popover
            :target="`popover-${type}-${index}`"
            triggers="hover"
            placement="right"
            variant="light"
        >
            <b-icon
                font-scale="1.5"
                animation="cylon"
                icon="arrow-left"
            ></b-icon>
        </b-popover>


    </div>
</template>

<script>
import VSelect from "vue-select";
import "vue-select/dist/vue-select.css";

import { dateFuncs } from "@/globs.js";


var timer;

export default {
    name: "JobTaskList",

    components: {},

    // things we have inherited from our parent
    props: ["index", "type", "engineers", "creating"],

    data() {
        return {
            isHovered: false,
        };
    },

    methods: {
        handleHover(hovered) {
            let vm = this;

            if (hovered) {
                timer = setTimeout(function () {
                    vm.isHovered = hovered;
                }, 500);
            } else {
                clearTimeout(timer);
                vm.isHovered = hovered;
            }
        },

        addTask(taskSubType) {
            this.$emit("add", this.type, this.index, taskSubType);
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/job/job-task-empty.vue